<template>
  <div class="box" id="sco">
    <div class="nav_box">
      <div class="nav_c">
        <ul>
          <li @click="toDo('6')">首页</li>
          <li @click="toDo('1')">铜雕</li>
          <li @click="toDo('2')">山水</li>
          <li @click="toDo('3')" style="color: #C9AE6C;background: rgba(255,255,255,1);">仕女</li>
          <li @click="toDo('4')">花鸟</li>
          <li @click="toDo('5')">神佛</li>
        </ul>
      </div>
    </div>
    <div class="boxx">
      <div class="shinv_index_box">
        <!-- 杨贵妃滚轮动画 -->
        <div class="head_box">
          <img class="gf" src="../images/shinv/gf.webp" />
          <img class="shan_left" src="../images/shinv/shan_left.png" />
          <img class="shan_right" src="../images/shinv/shan_rigt.png" />
          <div class="gf_old">
            <img class="gf_old" style="border: 1px solid #fff;" src="../images/shinv/gf_old.png" />
          </div>
          <!-- <div class="dj_ly"></div> -->
          <svg t="1682943609664" class="icon dj" viewBox="0 0 1024 1024" version="1.1"
            xmlns="http://www.w3.org/2000/svg" p-id="2682" width="200" height="200">
            <path
              d="M775.779 418.172l-2.051 0c-15.159 0-27.6 4.355-39.583 11.771-10.486-30.584-37.159-52.615-71.513-52.615-15.16 0-29.638 4.354-41.62 11.77-10.487-30.583-37.172-52.615-71.527-52.615-13.399 0-25.85 3.357-36.873 9.255l0-78.691c0-42.861-32.418-77.606-75.59-77.606-43.173 0-78.17 34.745-78.17 77.606l0 301.282-47.49-47.295c-30.528-30.306-84.558-25.992-110.55 0s-43.038 78.308-5.818 115.528l218.306 216.875c4.504 4.471 9.455 8.2 14.663 11.353 39.803 32.47 85.412 51.692 181.857 51.692 220.324 0 240.728-118.865 240.728-265.492L850.548 495.777C850.547 452.917 818.952 418.172 775.779 418.172zM809.403 650.988c0 124.069-0.593 224.647-199.585 224.647-84.298 0-134.907-18.796-173.246-56.858L229.904 613.455c-18.285-18.285-13.687-41.664 1.282-56.633 14.968-14.968 42.441-15.486 56.902-1.131 0 0 36.259 36.045 67.498 67.1 23.641 23.502 44.408 44.145 44.408 44.145l0-391.72c0-20.302 16.578-36.76 37.028-36.76 20.449 0 34.448 16.459 34.448 36.76l0 249.154 0.415 0c-0.27 1.32-0.415 2.685-0.415 4.085 0 11.278 9.21 20.423 20.571 20.423 11.36 0 20.57-9.144 20.57-20.423 0-1.4-0.144-2.765-0.415-4.085l0.415 0L512.611 422.257c0-20.302 14.795-36.761 35.245-36.761 0 0 36.232-0.49 36.232 36.761l0 134.787 0.415 0c-0.27 1.321-0.415 2.686-0.415 4.085 0 11.279 9.21 20.423 20.57 20.423 11.361 0 20.571-9.143 20.571-20.423 0-1.399-0.144-2.764-0.415-4.085l0.415 0 0-93.942c0-20.303 14.559-36.762 35.01-36.762 0 0 36.983 2.303 36.983 36.762l0 118.449 0.415 0c-0.269 1.32-0.415 2.686-0.415 4.085 0 11.279 9.21 20.423 20.571 20.423s20.055-9.143 20.055-20.423c0-1.399-0.136-2.765-0.392-4.085l0.392 0 0-80.872c0-20.302 15.255-36.761 35.704-36.761 0 0 35.851-1.45 35.851 36.761C809.403 500.679 809.403 617.954 809.403 650.988zM328.307 382.755l0-68.631c-6.531-14.641-10.24-30.817-10.24-47.884 0-65.037 52.723-117.76 117.76-117.76s117.76 52.723 117.76 117.76c0 8.884-1.05 17.509-2.935 25.82 14.812 0.578 28.176 6.726 37.904 16.597 3.771-13.518 5.99-27.685 5.99-42.417 0-87.658-71.062-158.72-158.72-158.72s-158.72 71.062-158.72 158.72C277.107 312.36 296.898 353.755 328.307 382.755z"
              p-id="2683" fill="#ffffff"></path>
          </svg>
          <img class="btn" src="../images/btn.webp" />
          <img class="gf_zi" src="../images/shinv/gf_zi.webp" />
          <img class="gf_shinv_zi" src="../images/shinv/gf_shinv_zi.png" />
          <img class="shinv_zi" src="../images/shinv/shinv_zi.png" />
        </div>
        <div class="content_box">
          <img class="gf_yun_2" src="../images/shinv/gf_yun_2.png" />
          <img class="gf_yun_4" src="../images/shinv/gf_yun_4.webp" />
          <img class="gf_tmh" src="../images/shinv/gf_tmh.png" />
          <img class="gf_2" src="../images/shinv/gf_2.webp" />
          <div class="zhou_box">
            <img class="hua" src="../images/shinv/hua.webp" />
          </div>
          <div class="sn_old"></div>
          <img class="yun" src="../images/shinv/yun.png" />
          <img class="hui" src="../images/shinv/hui.png" />
          <img class="btn_1" src="../images/btn.webp" />
          <img class="gf_pr" src="../images/shinv/gf_pr.png" />
          <img class="gf_2_zi" src="../images/shinv/gf_2_zi.png" />
          <img class="gf_zi_3" src="../images/shinv/gf_zi_3.png" />
        </div>
        <div class="botton_box">
          <img class="gf_yun_3" src="../images/shinv/gf_yun_3.png" />
          <img class="gf_xfr" src="../images/shinv/gf_xfr.webp" />
          <img class="gf_chuan" src="../images/shinv/gf_chuan.webp" />
          <img class="btn_3" src="../images/btn.webp" />
          <div class="cfr_old">
            <img class="cfr_old" style="transform: scale(0.8);border: 1px solid #fff;"
              src="../images/shinv/xfr_old.webp" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    methods: {
      // 页面跳转
      toDo(types) {
        if (types == "1") {
          this.$router.push({
            path: "/td"
          });
        } else if (types == "2") {
          this.$router.push({
            path: "/ss"
          });
        } else if (types == "3") {
          this.$router.push({
            path: "/gf"
          });
        } else if (types == "4") {
          this.$router.push({
            path: "/hn"
          });
        } else if (types == "5") {
          this.$router.push({
            path: "/fo"
          });
        } else if (types == "6") {
          this.$router.push({
            path: "/index"
          });
        }
      },
      // 首页贵妃
      gf() {
        // 贵妃对比
        $(".btn,.dj,.gf_old").mouseover(function() {
          $(".gf_old").stop().fadeIn()
          $(".dj").css("display", "none")
        })
        $(".btn,.dj,.gf_old").mouseout(function() {
          $(".gf_old").stop().fadeOut()
        })

        // 湘夫人对比
        $(".btn_3,.cfr_old").mouseover(function() {
          $(".cfr_old").stop().fadeIn()
        })
        $(".btn_3,.cfr_old").mouseout(function() {
          $(".cfr_old").stop().fadeOut()
        })
        // 初始化ScrollMagic控制器
        let controller = new ScrollMagic.Controller();
        //可见高度
        var viewH = parseInt($(document).height());
        // 按钮放大缩小
        (new TimelineLite).to(".btn,.btn_1,.btn_3", 1, {
            ease: Linear.easeNone,
            scale: 1.1,
            repeat: -1,
            yoyo: true,
          }),
          // 云 放大
          (new TimelineLite).to(".gf_yun_2", 8, {
            ease: Linear.easeNone,
            scale: 1.02,
            repeat: -1,
            x: 10,
            y: 10,
            yoyo: true,
          }), (new TimelineLite).to(".gf_yun_3, .gf_xfr", 5, {
            ease: Linear.easeNone,
            repeat: -1,
            x: 20,
            y: 20,
            yoyo: true,
          }), (new TimelineLite).to(".dj", 1.5, {
            ease: Linear.easeNone,
            top: "-6%",
            opacity: 0,
            repeat: -1,
          }), (new TimelineLite).to(".zhou_left", 2, {
            left: "-37%",
            ease: Linear.easeNone,
            repeat: 0,
          }), (new TimelineLite).to(".zhou_right", 2, {
            ease: Linear.easeNone,
            right: "-37%",
            repeat: 0,
          })


        // TweenMax动画
        let shan_left = (new TimelineLite).to(".shan_left", 1, {
            left: "-42.3513%",
            ease: Linear.easeNone,
          }),
          shan_right = (new TimelineLite).to(".shan_right", 1, {
            right: "-30.4256%",
            top: "10.338%",
            ease: Linear.easeNone
          }),
          shan_left_1 = (new TimelineLite).to(".shan_left", 1, {
            left: "-50%",
            ease: Linear.easeNone,
          }),
          shan_right_1 = (new TimelineLite).to(".shan_right", 1, {
            right: "-50%",
            top: "30%",
            ease: Linear.easeNone
          }),
          gf_chuan = (new TimelineLite).to(".gf_chuan", 1, {
            right: "0%",
            ease: Linear.easeNone
          }),
          yun = (new TimelineLite).to(".yun", 1, {
            opacity: 1,
            ease: Linear.easeNone
          }),
          hui = (new TimelineLite).to(".hui", 1, {
            opacity: 1,
            ease: Linear.easeNone
          }),
          gf_zi = (new TimelineLite).to(".gf_zi", 8, {
            opacity: 1,
            top: "-15%",
            left: "15%",
            width: "60%",
            ease: Linear.easeNone
          }),
          gf = (new TimelineLite).to(".gf", 1, {
            top: "58%",
            left: "-12.337%",
            scale: 0.698286,
            ease: Linear.easeNone
          }),
          gf_tmh = (new TimelineLite).to(".gf_tmh", 1, {
            top: "5%",
            width: "42%",
            right: "20%",
            scale: 0.8,
            ease: Linear.easeNone
          }),
          btn_1 = (new TimelineLite).to(".btn_1", 0.1, {
            opacity: 1,
            ease: Linear.easeNone
          })



        // ScrollMagic绑定动画
        new ScrollMagic.Scene({
          offset: 0,
          duration: 5000,
          triggerHook: 1,
        }).setPin(".shinv_index_box").setTween(gf_zi).addTo(controller);
        new ScrollMagic.Scene({
          offset: 6350,
          duration: 1000,
        }).setPin(".shinv_index_box").setTween(btn_1).addTo(controller);
        new ScrollMagic.Scene({
          offset: 6350,
          duration: 500,
        }).setTween(yun).addTo(controller);
        new ScrollMagic.Scene({
          offset: 6350,
          duration: 800,
        }).setTween(hui).addTo(controller);
        new ScrollMagic.Scene({
          offset: 0,
          duration: 2290,
        }).setTween(shan_left).addTo(controller);
        new ScrollMagic.Scene({
          offset: 0,
          duration: 2290,
        }).setTween(shan_right).addTo(controller);
        new ScrollMagic.Scene({
          offset: 2699,
          duration: 1000,
        }).setTween(shan_left_1).addTo(controller);
        new ScrollMagic.Scene({
          offset: 2699,
          duration: 1000,
        }).setTween(shan_right_1).addTo(controller);
        new ScrollMagic.Scene({
          offset: 5000,
          duration: 1290,
        }).setTween(gf).addTo(controller);
        new ScrollMagic.Scene({
          offset: 6100,
          duration: 249,
        }).setTween(gf_tmh).addTo(controller);
        new ScrollMagic.Scene({
          offset: 12000,
          duration: 1000,
        }).setTween(gf_chuan).addTo(controller);
      }
    },
    mounted: function() {
      this.gf();

    },
    created() {}
  }
</script>

<style scoped>
/*  .gun {
    position: absolute;
    width: 3.97%;
  }

  .zhou_right {
    position: absolute;
    width: 50%;
    height: 105%;
    z-index: 55;
    right: 0%;
    top: -3.5%;
  }

  .zhou_left {
    position: absolute;
    width: 50%;
    height: 105%;
    z-index: 55;
    left: 0%;
    top: -3.5%;
  }

  .zhou {
    width: 75.5%;
    position: absolute;
    z-index: 5;
    top: -1%;
  } */
  .hua{
    position: relative;
      width: 50%;
      left: 2%;
  }
  .zhou_box {
    position: absolute;
    width: 100%;
    z-index: 4;
    top: 72%;
    left: 20%;
  }

  .dj {
    position: absolute;
    top: -5%;
    left: 48%;
    cursor: pointer;
    z-index: 6;
    width: 3%;
    display: none;
  }

  @keyframes anim {

    0% {
      transform: scale(0);
      opacity: 0;
    }

    50% {
      opacity: 0.8;
    }

    100% {
      transform: scale(1);
      opacity: 0;
    }

  }

  .gf_tmh {
    position: absolute;
    width: 55%;
    right: 10%;
    top: -10%;
    z-index: 2;
  }

  .gf_old {
    position: absolute;
    border-radius: 1em;
    background-color: rgba(169, 149, 122);
    width: 60%;
    height: auto;
    top: 0%;
    right: 8%;
    z-index: 4;
    display: none;
  }

  .cfr_old {
    position: absolute;
    border-radius: 1em;
    background-color: rgba(169, 149, 122);
    width: 60%;
    height: auto;
    top: 26.6%;
    left: 31.4%;
    z-index: 4;
    display: none;
  }

  .sn_old {}

  .gf_shinv_zi {
    position: absolute;
    width: 30%;
    top: -20%;
    left: 52%;
    z-index: 3;
  }

  .gf_yun_4 {
    position: absolute;
    width: 125%;
    height: 50%;
    right: 0;
    top: 19%;
    z-index: 3;
  }

  .shinv_zi {
    position: absolute;
    width: 15%;
    left: 52%;
    top: -36%;
    z-index: 3;
  }

  .gf_chuan {
    position: absolute;
    width: 58%;
    bottom: 7%;
    right: -58%;
    z-index: 1;
  }

  .gf_xfr {
    position: absolute;
    width: 65%;
    top: 28%;
    left: 7%;
    z-index: 1;
  }

  .btn_3 {
    position: absolute;
    width: 4%;
    top: 26.5%;
    left: 50%;
    z-index: 2;
    cursor: pointer;
  }

  .gf_yun_3 {
    position: absolute;
    width: 100%;
    top: 30%;
    right: 0%;
    z-index: 2;
  }

  .gf_zi_3 {
    position: absolute;
    width: 33%;
    top: 138%;
    right: 10%;
    z-index: 2;
    opacity: 1;
  }

  .gf_2 {
    position: absolute;
    width: 28%;
    top: 70%;
    right: 16.6%;
    transform: scale(1.9);
    z-index: 6;
  }

  .gf_2_zi {
    position: absolute;
    width: 30%;
    top: 88%;
    left: 25%;
    opacity: 1;
    z-index: 2;
  }

  .gf_yun_2 {
    position: absolute;
    width: 100%;
    top: 95%;
    left: 0%;
    z-index: 3;
  }

  .gf_pr {
    position: absolute;
    width: 8%;
    top: 70%;
    left: 8%;
  }

  .box {
    z-index: 0;
    overflow: hidden;
  }

  .shinv_index_box {
    background: url("../images/shinv/bg.webp");
    background-size: 112%;
    background-repeat: no-repeat;
    z-index: 1;
  }

  .gf {
    position: relative;
    width: 50%;
    top: 10%;
    left: 15%;
    z-index: 4;
    transform: scale(1.6)
  }

  .shan_left {
    position: absolute;
    width: 65%;
    top: -40%;
    left: -17.5%;
    z-index: 4;
  }

  .shan_right {
    position: absolute;
    width: 65%;
    top: -10.6821%;
    right: -17.45%;
    z-index: 4;
  }

  .yun {
    position: absolute;
    width: 20%;
    height: auto;
    z-index: 3;
    left: 28%;
    top: 25%;
    opacity: 0;
  }

  .hui {
    position: absolute;
    width: 25%;
    height: auto;
    z-index: 3;
    left: 32.5%;
    top: 38%;
    opacity: 0;
  }

  .btn_1 {
    position: absolute;
    width: 4%;
    height: auto;
    z-index: 3;
    left: 33%;
    top: 20%;
    cursor: pointer;
    opacity: 0;
  }

  .btn {
    position: absolute;
    width: 4%;
    height: auto;
    z-index: 5;
    left: 47.4%;
    top: -5%;
    cursor: pointer;
    display: none;
  }

  .gf_zi {
    position: absolute;
    width: 41%;
    z-index: 0;
    left: 28%;
    top: -30%;
    opacity: 0;
  }


  .tou_box {
    position: relative;
    width: 100%;
    height: 62em;
  }

  .head_box {
    width: 100%;
    height: 120vh;
    position: relative;
    display: block;
    top: 50vh;
  }

  .content_box {
    width: 100%;
    display: block;
    height: 220vh;
    position: relative;
  }

  .botton_box {
    width: 100%;
    display: block;
    height: 380vh;
    position: relative;
  }
</style>
